import { gql } from "graphql-tag";
import { networkQualityThresholdFieldsFragment } from "../fragments/networkQualityThreshold";
import {
  streamProfileFieldsFragment,
  streamProfileOptionsFragment,
} from "../fragments/streamProfile";
import { gameFields, gameFieldsAaa } from "../fragments/game";

export const meGQL = gql`
  query MeProfile {
    me {
      avatar
      email
      idpName
      pushSubscription
      xp
      id
      idpId
      username
      language
      leaderboardRank(type: daily)
      phone
      tenantId
      metadata {
        billingInfo {
          name
          state
        }
        tags
        desiredStreamResolution
        hasReceivedWelcomeCoins
        hasSeenWelcomePopup
        lastSeenTransactionId
        tgpRecentlyPlayedItems
        tgpLikedItems
        onboarding
        tgpFavoriteItems {
          id
          linkType
          assets
          title
          data {
            ... on LinkFeaturedCardData {
              __typename
              redirectUrl
            }
            ... on PathFeaturedCardData {
              __typename
              internalPath
            }
          }
        }
        tgpRecentlyPlayed {
          id
          linkType
          assets
          title
          data {
            ... on LinkFeaturedCardData {
              __typename
              redirectUrl
            }
            ... on PathFeaturedCardData {
              __typename
              internalPath
            }
          }
        }
      }
      coinWallets {
        balance
        userId
        walletType
        itemType
      }
    }
  }
`;

export const meAAAGQL = gql`
  query MeAAAProfile {
    me {
      id
      username
      avatar
      email
      language
      phone
      tenantId
      totalTimePlayed
      totalPlayedGames
      metadata {
        billingInfo {
          name
          state
        }
        tags
        onboarding
      }
    }
  }
`;

export const getDeviceStreamConfigAAAGQL = gql`
  query GetDeviceStreamConfig($deviceInfo: DeviceInfoInput!) {
    me {
      id
      metadata {
        preferredEonCluster
      }
      deviceStreamConfig(deviceInfo: $deviceInfo) {
        label
        id
        config {
          bitrate
          fps
          resolution
        }
      }
    }
  }
`;

export const intercomTokenGQL = gql`
  query IntercomToken {
    me {
      id
      intercomToken {
        jwt
        expiresAt
      }
    }
  }
`;

export const achievementsGQL = gql`
  query Achievements($input: AchievementsInput) {
    me {
      achievements(input: $input) {
        total
        items {
          currentTier
          id
          nextTierTarget
          progress
        }
      }
    }
  }
`;

export const getUserB2bSubscriptionGQL = gql`
  query Subscription {
    me {
      subscription {
        status
        redirectUrl
        renewalDate
        topUpUrl
        managementUrl
      }
    }
  }
`;

export const getAAASubscriptionGQL = gql`
  query Subscription {
    me {
      id
      phone
      avatar
      subscription {
        status
        validUntil
        planId
        isRecurring
        renewalDate
        type
        plan {
          labels
          planAmount
          duration
          metadata
        }
      }
    }
  }
`;

export const getSubscriptionPlansGQL = gql`
  query SubscriptionPlans($input: ListSubscriptionPlansInput!) {
    subscriptionPlans(input: $input) {
      items {
        id
        externalPlanId
        planAmount
        itemAmount
        duration
        walletType
        itemType
        labels
        assets
        metadata
        gateway
        position
      }
      total
    }
  }
`;

export const coinWalletsGQL = gql`
  query CoinWallets {
    me {
      coinWallets {
        balance
        userId
        walletType
        itemType
      }
    }
  }
`;

export const lastActiveGameSessionGQL = gql`
  query LastActiveGameSession {
    me {
      id
      lastActiveGameSession {
        id
        launchData {
          ... on CasualHtmlLaunchData {
            __typename
            gameConfig
            launchUrl
          }
          ... on N2IStreamLaunchData {
            __typename
            launchUrl
            sessionId
          }
          ... on PCStreamLaunchData {
            __typename
            city
            country
            launchUrl
            streamStatusUrl
            time
            date
            bitrate
            streamData {
              profile {
                ...StreamProfileFields
              }
              limits {
                bitrate {
                  min
                  max
                }
              }
              thresholds {
                ...NetworkQualityThresholdFields
              }
            }
          }
          ... on BlacknutStreamLaunchData {
            __typename
            accessToken
            blacknutGameId
            refreshToken
          }
        }
        status
        game {
          metadata
          id
          type
          orientation
          title
          category
        }
      }
    }
  }
  ${streamProfileFieldsFragment}
  ${networkQualityThresholdFieldsFragment}
`;

export const getUserProfileCaGQL = gql`
  query User($id: UUID!) {
    user(id: $id) {
      totalTimePlayed
      totalPlayedGames
      xp
    }
  }
`;

export const getUserProfileTgpGQL = gql`
  query User(
    $id: UUID!
    $achievementsInput: AchievementsInput
    $transactionsInput: TransactionsInput
  ) {
    user(id: $id) {
      avatar
      followStatus
      id
      leaderboardRank
      username
      xp
      matchesPlayed
      following {
        total
      }
      followers {
        total
      }
      transactions(input: $transactionsInput) {
        items {
          amount
          coinType
          date
          expiryDate
          id
          receivedOn
          referenceId
          type
          game {
            id
            title
            metadata
          }
        }
      }
      achievements(input: $achievementsInput) {
        total
        items {
          currentTier
          id
          nextTierTarget
          progress
        }
      }
      loginStreak
    }
  }
`;

export const getUserVodabucksTransactionsGQL = gql`
  query UserVodabucksTransactions(
    $id: UUID!
    $transactionsInput: TransactionsInput
  ) {
    user(id: $id) {
      id
      transactions(input: $transactionsInput) {
        items {
          amount
          coinType
          date
          expiryDate
          id
          receivedOn
          referenceId
          type
          game {
            id
            title
            metadata
          }
        }
      }
    }
  }
`;

export const getStrangeProfileTgpGQL = gql`
  query User($id: UUID!, $achievementsInput: AchievementsInput) {
    user(id: $id) {
      avatar
      followStatus
      id
      leaderboardRank
      username
      xp
      matchesPlayed
      following {
        total
      }
      followers {
        total
      }
      achievements(input: $achievementsInput) {
        total
        items {
          currentTier
          id
          nextTierTarget
          progress
        }
      }
      loginStreak
    }
  }
`;

export const getUserProfileAppGQL = gql`
  query User($id: UUID!) {
    user(id: $id) {
      avatar
      followStatus
      id
      leaderboardRank
      username
      xp
      following {
        total
      }
      followers {
        total
      }
      challengesCompleted
      matchesWon
      matchesPlayed
      isFriendBattleAllowed
      battleStreak {
        best
        current
      }
      lastActive {
        time
      }
    }
  }
`;

export const getUserStatusGQL = gql`
  query User($id: UUID!) {
    user(id: $id) {
      followStatus
      id
    }
  }
`;

export const userTransactionsGQL = gql`
  query User($id: UUID!, $coinTypes: [CoinType!], $limit: Int!, $offset: Int!) {
    user(id: $id) {
      transactions(
        input: {
          coinTypes: $coinTypes
          page: { limit: $limit, offset: $offset }
        }
      ) {
        total
        items {
          amount
          coinType
          date
          expiryDate
          id
          referenceId
          type
          game {
            category
            data
            description
            featured
            hasBattle
            hasSolo
            hasTournament
            id
            rotationMode
            status
            title
            type
          }
        }
      }
    }
  }
`;

export const getConfigGQL = gql`
  query Config {
    config {
      freeCoins {
        amount
      }
      prizePools {
        battle {
          coinType
          coinsLoser
          coinsWinner
        }
        challenge {
          coinsCompletion
          coinType
          coinsFailure
          coinsFirstTimeCompletion
        }
        tournament {
          id
          coinType
          prizePool {
            prize
            toRank
          }
        }
        casual {
          coinType
          coinsPerMinute
          maxCoinsPerSession
        }
      }
      tierLevels {
        amount
        levelId
      }
    }
  }
`;

export const loginRewardsGQL = gql`
  query {
    loginRewards {
      ... on CoinLoginReward {
        __typename
        amount
        claimStatus
        walletType
        itemType
      }
      ... on AchievementLoginReward {
        __typename
        amount
        walletType
        claimStatus
        achievementType: itemType
      }
    }
  }
`;

export const getLeaderboardRankGQL = gql`
  query User($id: UUID!) {
    user(id: $id) {
      leaderboardRank
    }
  }
`;

export const getFollowingUsersGQL = gql`
  query User($id: UUID!, $input: FollowUsersInput) {
    user(id: $id) {
      id
      following(input: $input) {
        total
        items {
          user {
            id
            avatar
            username
            xp
            followStatus
            isFriendBattleAllowed
            lastActive {
              time
            }
          }
        }
      }
    }
  }
`;
export const getFollowerUsersGQL = gql`
  query User($id: UUID!, $input: FollowUsersInput) {
    user(id: $id) {
      id
      followers(input: $input) {
        total
        items {
          user {
            id
            avatar
            username
            xp
            followStatus
            isFriendBattleAllowed
            lastActive {
              time
            }
          }
        }
      }
    }
  }
`;

export const followSuggestionsGQL = gql`
  query FollowSuggestions {
    followSuggestions {
      criteria
      user {
        id
        avatar
        username
        xp
        followStatus
        isFriendBattleAllowed
        lastActive {
          time
        }
      }
    }
  }
`;

export const contentVideosGQL = gql`
  query ContentVideos($type: VideoType!, $params: VideoParams) {
    contentVideos(type: $type, params: $params) {
      description
      id
      publishedAt
      title
      thumbnailUrl {
        default
        high
        medium
      }
    }
  }
`;

export const recentlyPlayedGamesGQL = gql`
  ${gameFields}
  query RecentlyPlayedGames($input: RecentlyPlayedGamesInput) {
    me {
      id
      recentlyPlayedGames(input: $input) {
        ...GameFields
      }
    }
  }
`;

export const featuredCardsGql = gql`
  ${gameFields}
  query FeaturedCards($input: FeaturedCardQueryInput) {
    featuredCards(input: $input) {
      items {
        data {
          ... on LinkFeaturedCardData {
            __typename
            redirectUrl
          }
          ... on PathFeaturedCardData {
            __typename
            internalPath
          }
          ... on TournamentFeaturedCardData {
            __typename
          }
          ... on GameFeaturedCardData {
            __typename
            game {
              ...GameFields
            }
          }
          __typename
        }
        id
        imageUrl
        assets
        title
        linkType
        metadata
        position
        __typename
      }
      __typename
    }
  }
`;

export const recentlyPlayedGamesAaaGQL = gql`
  ${gameFieldsAaa}
  query RecentlyPlayedGames($input: RecentlyPlayedGamesInput) {
    me {
      id
      recentlyPlayedGames(input: $input) {
        ...GameFieldsAaa
      }
    }
  }
`;

export const featuredCardsAaaGql = gql`
  ${gameFieldsAaa}
  query FeaturedCards($input: FeaturedCardQueryInput) {
    featuredCards(input: $input) {
      items {
        data {
          ... on LinkFeaturedCardData {
            __typename
            redirectUrl
          }
          ... on PathFeaturedCardData {
            __typename
            internalPath
          }
          ... on TournamentFeaturedCardData {
            __typename
          }
          ... on GameFeaturedCardData {
            __typename
            game {
              ...GameFieldsAaa
            }
          }
          __typename
        }
        id
        imageUrl
        assets
        title
        linkType
        metadata
        position
        __typename
      }
      __typename
    }
  }
`;

export const featuredCardsPackGql = gql`
  query FeaturedCards($input: FeaturedCardQueryInput) {
    featuredCards(input: $input) {
      items {
        group
        id
        imageUrl
        linkType
        position
        data {
          ... on LinkFeaturedCardData {
            __typename
            redirectUrl
          }
          ... on PathFeaturedCardData {
            __typename
            internalPath
          }
          ... on TournamentFeaturedCardData {
            __typename
          }
        }
      }
    }
  }
`;

export const newsGQL = gql`
  query News($params: NewsQueryInput!) {
    news(input: $params) {
      items {
        author
        description
        image
        language
        publishedDate
        source
        title
        url
        category
      }
      total
    }
  }
`;

export const getTGPSubscriptionGQL = gql`
  query Me {
    me {
      subscriptions {
        status
        product {
          id
          title
          icon
        }
        redirectUrl
        renewalDate
        productId
      }
    }
  }
`;

export const vodabucksBalanceGQL = gql`
  query vodabucksBalance($input: VodabucksBalanceInput!) {
    vodabucksBalance(input: $input) {
      balance
    }
  }
`;

export const EonClusterDetailsGQL = gql`
  query EonClusterDetails {
    eonClusterDetails {
      name
      domain
    }
  }
`;

export const eonLinkAccountsGQL = gql`
  query EonLinkAccounts {
    me {
      id
      eonLinkedAccounts {
        provider
        status
      }
    }
  }
`;

export const getStreamProfilesGQL = gql`
  query StreamProfiles {
    config {
      streamProfiles {
        ...StreamProfileFields
        ...StreamProfileOptions
      }
    }
  }
  ${streamProfileFieldsFragment}
  ${streamProfileOptionsFragment}
`;

export const getDeviceStreamConfigGQL = gql`
  query DeviceStreamConfig($deviceInfo: DeviceInfoInput!) {
    me {
      id
      deviceStreamConfig(deviceInfo: $deviceInfo) {
        ...StreamProfileFields
        ...StreamProfileOptions
      }
    }
  }
  ${streamProfileFieldsFragment}
  ${streamProfileOptionsFragment}
`;

export const getConfigAAAGQL = gql`
  query Config {
    config {
      streamProfiles {
        config {
          bitrate
          fps
          resolution
        }
        label
        id
        enabled
        options {
          supportedBitrate {
            enabled
            value
          }
          supportedFPS {
            enabled
            value
          }
          supportedResolution {
            enabled
            value
          }
        }
      }
    }
  }
`;

export const productsByTenantGQL = gql`
  query ProductsByTenant($input: ProductsByTenantInput!) {
    productsByTenant(input: $input) {
      items {
        id
        appUrl
        productBranding {
          icon
          title
        }
      }
    }
  }
`;

export const getGameLibraryGQL = gql`
  query GameLibrary($input: GameLibraryInput) {
    me {
      id
      gameLibrary(input: $input) {
        total
        items {
          id
          game {
            id
            title
            category
            metadata
          }
        }
      }
    }
  }
`;
